import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" kopiere die Adressdaten aus WAVE in deine Zwischenablage (Copy & Paste) in dieses Feld: ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Öffne WAVE auf deinem Computer.")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Klicke bei ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", null, "Mitgliederverwaltung > Mitglied", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" auf das Auswahl Icon ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Wähle folgende Einstellung ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", null, "Selektion: MRV-Geburtstagskartengenerator", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, "Selektion: MRV-Taufjubiläumskartengenerator", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Markiere die ganze Ausgabe (Eine Zeile anklicken, dann Strg-A) ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Kopiere die ganze Ausgabe (Rechtsklick > Markierte Datensätze kopieren) ")
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", null, "Datenvorschau", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GetClipboard = _resolveComponent("GetClipboard")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, "Importiere die Daten für die " + _toDisplayString(_ctx.greetingCardService.cardType), 1),
      _createElementVNode("p", null, [
        _createTextVNode(" Um die Daten für die " + _toDisplayString(_ctx.greetingCardService.cardType) + " zu importieren,", 1),
        _hoisted_2,
        _hoisted_3
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_GetClipboard, {
          onDataValid: _cache[0] || (_cache[0] = ($event: any) => (_ctx.greetingCardService.addressData = $event))
        })
      ]),
      _createVNode(_component_Button, {
        class: "p-mr-2 p-button-secondary",
        type: "submit",
        label: "Zurück",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('1')))
      }),
      _createVNode(_component_Button, {
        class: _normalizeClass(["p-mr-2", {
        'p-button-secondary': !_ctx.greetingCardService.addressData.length,
      }]),
        disabled: !_ctx.greetingCardService.addressData.length,
        type: "submit",
        label: "Weiter",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('3')))
      }, null, 8, ["class", "disabled"]),
      _hoisted_4
    ]),
    (!_ctx.greetingCardService.addressData.length)
      ? (_openBlock(), _createBlock(_component_Accordion, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_AccordionTab, { header: "Anleitung: So kommst du an die Adressdaten aus WAVE" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, [
                    _createVNode(_component_Badge, { value: "1" }),
                    _hoisted_5
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_Badge, { value: "2" }),
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _hoisted_9,
                  _createVNode(_component_Badge, { value: "3" }),
                  _hoisted_10,
                  (_ctx.greetingCardService.cardType == 'Geburtstagskarte')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_11, _hoisted_13))
                    : _createCommentVNode("", true),
                  (_ctx.greetingCardService.cardType == 'Taufjubiläumskarte')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_14, _hoisted_16))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, [
                    _createVNode(_component_Badge, { value: "4" }),
                    _hoisted_17
                  ]),
                  _createElementVNode("p", null, [
                    _createVNode(_component_Badge, { value: "4" }),
                    _hoisted_18
                  ])
                ]),
                _createVNode(_component_Button, {
                  class: "p-mr-2 clipboard-btn",
                  type: "submit",
                  "data-clipboard-text": _ctx.greetingCardService.exampleRawData,
                  icon: "pi pi-copy",
                  label: "Kopiere Beispieldaten in die Zwischenablage"
                }, null, 8, ["data-clipboard-text"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.greetingCardService.addressData.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_DataTable, {
            value: _ctx.greetingCardService.addressData,
            responsiveLayout: "scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "vorname",
                header: "Vorname"
              }),
              _createVNode(_component_Column, {
                field: "name",
                header: "Nachname"
              }),
              _createVNode(_component_Column, {
                field: "geburtsdatum",
                header: "Geburtstag"
              }),
              _createVNode(_component_Column, {
                field: "plzNavi",
                header: "Postleitzahl"
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}